<p>user-guest-location works!</p>
